import React, { useContext, useRef } from 'react';
import { Vertex } from '../../../../../types';
import EntityDrawer from '../EntityDrawerContainer';
import {
  EntityDrawerPropsApollo,
  EntityDrawerPropsStatic,
} from '../useEntityDrawer';

interface PropsApolloChild extends EntityDrawerPropsApollo {
  children: React.ReactNode;
}
interface PropsStaticChild extends EntityDrawerPropsStatic {
  children: React.ReactNode;
}
type Props = PropsApolloChild & PropsStaticChild;

interface EntityDrawerHookResult {
  setVertexId: (vertexId?: string) => void;
  setVertex: (vertex?: Vertex) => void;
}

const EntityDrawerDispatchContext = React.createContext<EntityDrawerHookResult>(
  {} as any // always defined with provider
);

const EntityDrawerHookProvider = ({ children, onClose, ...props }: Props) => {
  const vertexId = useRef<string>();
  const vertex = useRef<Vertex>();

  const setVertex: EntityDrawerHookResult['setVertex'] = (newVertex) => {
    vertex.current = newVertex;
    vertexId.current = undefined;
  };

  const setVertexId: EntityDrawerHookResult['setVertexId'] = (newVertexId) => {
    vertex.current = undefined;
    vertexId.current = newVertexId;
  };

  return (
    <EntityDrawerDispatchContext.Provider
      value={{
        setVertex,
        setVertexId,
      }}
    >
      {children}
      <EntityDrawer
        vertexId={vertexId.current}
        vertex={vertex.current}
        onClose={
          onClose
            ? () => {
                setVertexId();
                onClose();
              }
            : undefined
        }
        {...props}
      />
    </EntityDrawerDispatchContext.Provider>
  );
};

const useEntityDrawer = () => {
  return useContext(EntityDrawerDispatchContext);
};

export { EntityDrawerHookProvider };

export default useEntityDrawer;
